# start = l'elemento di partenza (0 è il primo)
# scroll = di quanti elementi deve scrollare
# step = la classe degli elementi
# slider = la classe del contenitore degli elementi
# show-width = la larghezza in cui far comparire il carousel (se non presente sarà sempre visibile)
# <div data-gencarousel="true" data-start="1" data-scroll="1" data-slider=".slider" data-step=".step" data-show-width="431">
#   <a class="arrow prev"></a>
#   <div class="content-slider">
#     <div class="slider">
#       <div class="step"></div>
#       ...
#     </div>
#   </div>
#   <a class="arrow next"></a>
# </div>

$.fn.gencarousel = (action=null)->
  content = $(@)
  return @ if content.length == 0
  slider = if content.data().slider? then content.find(content.data().slider) else content.find(".slider")
  steps = if content.data().step? then content.find(content.data().step) else content.children(".step")

  _options = {}
  _options.start = if content.data().start? then parseInt(content.data().start, 10) else 1
  content.data("current", _options.start) unless content.data().current?
  _options.current_show = content.data("current")
  _options.scroll = if content.data().scroll? then parseInt(content.data().scroll, 10) else 1
  _options.width_step = 0
  _options.maxLeft = 0
  _options.minLeft = 0
  window["#{content.attr("id")}_gencarousel_options"] = _options

  showHideArrows = ->
    options = window["#{content.attr("id")}_gencarousel_options"]
    if (content.data().showWidth? and $(window).width() < parseInt(content.data().showWidth, 10)) or not content.data().showWidth?
      if options.current_show == 0
        content.find(".arrow.prev").hide().addClass('disabled')
      else
        content.find(".arrow.prev").show().removeClass('disabled')

      if options.current_show == steps.length - options.scroll
        content.find(".arrow.next").hide().addClass('disabled')
      else
        content.find(".arrow.next").show().removeClass('disabled')

  slideGenCarousel = (event)->
    options = window["#{content.attr("id")}_gencarousel_options"]
    event.preventDefault()
    arrow = $(@)
    unless arrow.hasClass('disabled')
      content.find(".arrow").addClass('disabled')
      currentLeft = parseInt slider.css('left'), 10
      if arrow.hasClass('next')
        animateLeft = currentLeft - (options.width_step * options.scroll)
        animateLeft = options.minLeft if animateLeft < options.minLeft
        arrow.hide() if animateLeft == options.minLeft
        slider.animate
          left: animateLeft
        , ->
          new_current_show = options.current_show + options.scroll
          new_current_show = (steps.length - options.scroll) if new_current_show > (steps.length - options.scroll)
          content.data("current", new_current_show)
          options.current_show = new_current_show
          showHideArrows()
      else
        animateLeft = currentLeft + (options.width_step * options.scroll)
        animateLeft = options.maxLeft if animateLeft > options.maxLeft
        arrow.hide() if animateLeft == options.maxLeft
        slider.animate
          left: animateLeft
        , ->
          new_current_show = options.current_show - options.scroll
          new_current_show = 0 if new_current_show < 0
          content.data("current", new_current_show)
          options.current_show = new_current_show
          showHideArrows()
      window["#{content.attr("id")}_gencarousel_options"] = options

  mobileSlideGenCarousel = ->
    options = window["#{content.attr("id")}_gencarousel_options"]
    if (content.data().showWidth? and $(window).width() < content.data().showWidth) or not content.data().showWidth?
      slider.on "swipeleft", ->
        content.find(".arrow.next").trigger("click") if content.find(".arrow.next")
      slider.on "swiperight", ->
        content.find(".arrow.prev").trigger("click") if content.find(".arrow.prev")

  fixWithSliderGenCarousel = ->
    options = window["#{content.attr("id")}_gencarousel_options"]
    options.width_step = slider.width() / steps.length
    options.minLeft = (slider.width() - content.width()) * -1
    if (content.data().showWidth? and $(window).width() < parseInt(content.data().showWidth, 10)) or not content.data().showWidth?
      animateLeft = (options.current_show * options.width_step) * -1
      if animateLeft < options.minLeft
        animateLeft = options.minLeft
        options.current_show = (options.minLeft / options.width_step) * -1
      slider.css "left", animateLeft
      unless action == "refresh"
        showHideArrows()
    else
      content.data("current", options.start)
      options.current_show = options.start
      slider.removeAttr("style")
      content.find(".arrow").removeAttr("style")
    window["#{content.attr("id")}_gencarousel_options"] = options

  fixWithSliderGenCarousel()
  mobileSlideGenCarousel()
  if action == "refresh"
    showHideArrows()

  unless action
    content.find(".arrow").on "click", slideGenCarousel
    $(window).on "resize", fixWithSliderGenCarousel
    $(window).on "resize", mobileSlideGenCarousel

  return content